import { setupGA } from './ga';
import { setupSentry } from './sentry';
import { setupHotjar, trackSpaRoute, trackHotjarEvent } from './hotjar';

export function initAnalytics() {
  setupGA();
  setupSentry();
  setupHotjar();
}

export { trackSpaRoute, trackHotjarEvent };

export function trackPageView(path) {
  window.gtag?.('event', 'page_view', { page_path: path });
}

export function trackEvent(name, params) {
  window.gtag?.('event', name, params);
}
